var map = {
  "./prism-iecst.js": [
    "36794",
    "276"
  ],
  "./prism-inform7.js": [
    "48880",
    "4670"
  ],
  "./prism-ruby.js": [
    "41648",
    "8510"
  ],
  "./prism-scheme.js": [
    "14183",
    "4227"
  ],
  "./prism-smarty.js": [
    "99124",
    "2578"
  ],
  "./prism-typescript.js": [
    "59587",
    "7907"
  ],
  "./prism-brightscript.js": [
    "78575",
    "6187"
  ],
  "./prism-swift.js": [
    "54793",
    "7877"
  ],
  "./prism-uorazor.js": [
    "59574",
    "2964"
  ],
  "./prism-n1ql.js": [
    "79988",
    "8062"
  ],
  "./prism-nsis.js": [
    "57787",
    "2555"
  ],
  "./prism-factor.js": [
    "61507",
    "9319"
  ],
  "./prism-avro-idl.js": [
    "25442",
    "8588"
  ],
  "./prism-js-templates.js": [
    "54029",
    "8549"
  ],
  "./prism-asciidoc.js": [
    "46371",
    "7903"
  ],
  "./prism-mel.js": [
    "60416",
    "8338"
  ],
  "./prism-renpy.js": [
    "60636",
    "3798"
  ],
  "./prism-jq.js": [
    "42177",
    "3201"
  ],
  "./prism-bbj.js": [
    "35328",
    "1953"
  ],
  "./prism-soy.js": [
    "18731",
    "8139"
  ],
  "./prism-tcl.js": [
    "13645",
    "6241"
  ],
  "./prism-crystal.js": [
    "11380",
    "6730"
  ],
  "./prism-lilypond.js": [
    "74215",
    "1211"
  ],
  "./prism-plsql.js": [
    "85106",
    "928"
  ],
  "./prism-v.js": [
    "44036",
    "4922"
  ],
  "./prism-cooklang.js": [
    "36340",
    "1074"
  ],
  "./prism-xeora.js": [
    "52639",
    "9967"
  ],
  "./prism-dot.js": [
    "84497",
    "3997"
  ],
  "./prism-css-extras.js": [
    "25365",
    "3157"
  ],
  "./prism-dataweave.js": [
    "5372",
    "8225"
  ],
  "./prism-julia.js": [
    "60463",
    "1163"
  ],
  "./prism-tt2.js": [
    "18872",
    "7270"
  ],
  "./prism-erlang.js": [
    "37099",
    "8187"
  ],
  "./prism-rest.js": [
    "71806",
    "2548"
  ],
  "./prism-php-extras.js": [
    "55248",
    "638"
  ],
  "./prism-python.js": [
    "52342",
    "7988"
  ],
  "./prism-tsx.js": [
    "82769",
    "8677"
  ],
  "./prism-warpscript.js": [
    "43037",
    "4213"
  ],
  "./prism-squirrel.js": [
    "88191",
    "5503"
  ],
  "./prism-avisynth.js": [
    "17224",
    "1754"
  ],
  "./prism-keepalived.js": [
    "54054",
    "3274"
  ],
  "./prism-makefile.js": [
    "30260",
    "6962"
  ],
  "./prism-textile.js": [
    "64379",
    "4667"
  ],
  "./prism-sqf.js": [
    "85540",
    "6862"
  ],
  "./prism-yang.js": [
    "18981",
    "9273"
  ],
  "./prism-git.js": [
    "85818",
    "1656"
  ],
  "./prism-ini.js": [
    "70824",
    "4342"
  ],
  "./prism-basic.js": [
    "87336",
    "1614"
  ],
  "./prism-cil.js": [
    "89262",
    "3172"
  ],
  "./prism-smali.js": [
    "3842",
    "4448"
  ],
  "./prism-naniscript.js": [
    "48607",
    "2439"
  ],
  "./prism-autoit.js": [
    "9118",
    "6712"
  ],
  "./prism-q.js": [
    "84113",
    "8137"
  ],
  "./prism-nasm.js": [
    "55877",
    "2649"
  ],
  "./prism-pcaxis.js": [
    "70736",
    "4854"
  ],
  "./prism-clike.js": [
    "75624",
    "1594"
  ],
  "./prism-markup-templating.js": [
    "19700",
    "5166"
  ],
  "./prism-go.js": [
    "86378",
    "6680"
  ],
  "./prism-pure.js": [
    "86318",
    "8848"
  ],
  "./prism-maxscript.js": [
    "32851",
    "6071"
  ],
  "./prism-agda.js": [
    "77099",
    "4555"
  ],
  "./prism-handlebars.js": [
    "43800",
    "8094"
  ],
  "./prism-javascript.js": [
    "25723",
    "2443"
  ],
  "./prism-powershell.js": [
    "30905",
    "677"
  ],
  "./prism-moonscript.js": [
    "71386",
    "6912"
  ],
  "./prism-java.js": [
    "96976",
    "8390"
  ],
  "./prism-al.js": [
    "27849",
    "3725"
  ],
  "./prism-dart.js": [
    "60869",
    "8037"
  ],
  "./prism-purescript.js": [
    "29405",
    "6673"
  ],
  "./prism-javadoclike.js": [
    "35643",
    "8311"
  ],
  "./prism-hsts.js": [
    "79788",
    "7714"
  ],
  "./prism-gherkin.js": [
    "12420",
    "2046"
  ],
  "./prism-nim.js": [
    "37110",
    "3100"
  ],
  "./prism-wolfram.js": [
    "65882",
    "3076"
  ],
  "./prism-sass.js": [
    "99562",
    "84"
  ],
  "./prism-rescript.js": [
    "19514",
    "2256"
  ],
  "./prism-metafont.js": [
    "52220",
    "710"
  ],
  "./prism-csharp.js": [
    "5651",
    "7059"
  ],
  "./prism-bqn.js": [
    "45663",
    "167"
  ],
  "./prism-r.js": [
    "27768",
    "2966"
  ],
  "./prism-antlr4.js": [
    "71313",
    "2317"
  ],
  "./prism-cobol.js": [
    "80065",
    "5169"
  ],
  "./prism-cue.js": [
    "57193",
    "2381"
  ],
  "./prism-django.js": [
    "62091",
    "3695"
  ],
  "./prism-ignore.js": [
    "8714",
    "4704"
  ],
  "./prism-chaiscript.js": [
    "65910",
    "2500"
  ],
  "./prism-jolie.js": [
    "3717",
    "7245"
  ],
  "./prism-json5.js": [
    "10267",
    "7043"
  ],
  "./prism-mata.js": [
    "645",
    "8865"
  ],
  "./prism-oz.js": [
    "13885",
    "2006"
  ],
  "./prism-powerquery.js": [
    "97551",
    "6459"
  ],
  "./prism-d.js": [
    "27966",
    "8336"
  ],
  "./prism-t4-cs.js": [
    "23119",
    "3543"
  ],
  "./prism-vbnet.js": [
    "47501",
    "3857"
  ],
  "./prism-cilkc.js": [
    "97512",
    "6870"
  ],
  "./prism-kumir.js": [
    "62486",
    "4008"
  ],
  "./prism-bash.js": [
    "57022",
    "4492"
  ],
  "./prism-gettext.js": [
    "11441",
    "6141"
  ],
  "./prism-jsx.js": [
    "65903",
    "9559"
  ],
  "./prism-xojo.js": [
    "62742",
    "8584"
  ],
  "./prism-sas.js": [
    "93391",
    "1023"
  ],
  "./prism-reason.js": [
    "1396",
    "8474"
  ],
  "./prism-sql.js": [
    "96966",
    "7292"
  ],
  "./prism-bison.js": [
    "99669",
    "6253"
  ],
  "./prism-vim.js": [
    "80046",
    "52"
  ],
  "./prism-qsharp.js": [
    "41329",
    "805"
  ],
  "./prism-systemd.js": [
    "42237",
    "418"
  ],
  "./prism-apex.js": [
    "67476",
    "2834"
  ],
  "./prism-idris.js": [
    "37723",
    "1243"
  ],
  "./prism-matlab.js": [
    "65961",
    "9625"
  ],
  "./prism-nevod.js": [
    "28904",
    "7190"
  ],
  "./prism-sml.js": [
    "23466",
    "7408"
  ],
  "./prism-graphql.js": [
    "34619",
    "9723"
  ],
  "./prism-yaml.js": [
    "60083",
    "367"
  ],
  "./prism-cshtml.js": [
    "30019",
    "991"
  ],
  "./prism-asm6502.js": [
    "62694",
    "4068"
  ],
  "./prism-csv.js": [
    "62630",
    "6732"
  ],
  "./prism-log.js": [
    "78160",
    "9570"
  ],
  "./prism-processing.js": [
    "14775",
    "8615"
  ],
  "./prism-pug.js": [
    "28882",
    "5128"
  ],
  "./prism-neon.js": [
    "5796",
    "918"
  ],
  "./prism-unrealscript.js": [
    "36472",
    "98"
  ],
  "./prism-dax.js": [
    "40555",
    "5547"
  ],
  "./prism-gap.js": [
    "76862",
    "9468"
  ],
  "./prism-odin.js": [
    "52748",
    "7026"
  ],
  "./prism-jsstacktrace.js": [
    "52850",
    "9172"
  ],
  "./prism-haml.js": [
    "40418",
    "4896"
  ],
  "./prism-go-module.js": [
    "75955",
    "7151"
  ],
  "./prism-qore.js": [
    "84709",
    "681"
  ],
  "./prism-icu-message-format.js": [
    "14487",
    "4975"
  ],
  "./prism-sparql.js": [
    "70537",
    "9021"
  ],
  "./prism-perl.js": [
    "32821",
    "7557"
  ],
  "./prism-apl.js": [
    "76181",
    "6517"
  ],
  "./prism-javastacktrace.js": [
    "87881",
    "1897"
  ],
  "./prism-mizar.js": [
    "77185",
    "6273"
  ],
  "./prism-gml.js": [
    "36774",
    "8452"
  ],
  "./prism-latte.js": [
    "6784",
    "7250"
  ],
  "./prism-xml-doc.js": [
    "83960",
    "6890"
  ],
  "./prism-linker-script.js": [
    "95635",
    "1379"
  ],
  "./prism-nginx.js": [
    "99486",
    "7212"
  ],
  "./prism-typoscript.js": [
    "38689",
    "5173"
  ],
  "./prism-ichigojam.js": [
    "86597",
    "3141"
  ],
  "./prism-lisp.js": [
    "10116",
    "3310"
  ],
  "./prism-tremor.js": [
    "99009",
    "585"
  ],
  "./prism-jsonp.js": [
    "70696",
    "2538"
  ],
  "./prism-bnf.js": [
    "22248",
    "2422"
  ],
  "./prism-fsharp.js": [
    "47782",
    "9328"
  ],
  "./prism-monkey.js": [
    "11621",
    "181"
  ],
  "./prism-http.js": [
    "24784",
    "6918"
  ],
  "./prism-birb.js": [
    "86061",
    "7645"
  ],
  "./prism-gradle.js": [
    "43523",
    "3855"
  ],
  "./prism-n4js.js": [
    "66449",
    "5582"
  ],
  "./prism-visual-basic.js": [
    "88835",
    "6363"
  ],
  "./prism-coq.js": [
    "87123",
    "1971"
  ],
  "./prism-cypher.js": [
    "53575",
    "5899"
  ],
  "./prism-shell-session.js": [
    "60061",
    "3805"
  ],
  "./prism-firestore-security-rules.js": [
    "59576",
    "7790"
  ],
  "./prism-bbcode.js": [
    "42493",
    "6833"
  ],
  "./prism-t4-vb.js": [
    "99717",
    "8997"
  ],
  "./prism-haskell.js": [
    "554",
    "8468"
  ],
  "./prism-mermaid.js": [
    "4201",
    "701"
  ],
  "./prism-regex.js": [
    "75133",
    "6114"
  ],
  "./prism-cmake.js": [
    "72509",
    "6069"
  ],
  "./prism-nand2tetris-hdl.js": [
    "9121",
    "4813"
  ],
  "./prism-ftl.js": [
    "27308",
    "3298"
  ],
  "./prism-batch.js": [
    "40990",
    "2328"
  ],
  "./prism-uri.js": [
    "34248",
    "1198"
  ],
  "./prism-vala.js": [
    "76410",
    "9908"
  ],
  "./prism-openqasm.js": [
    "88530",
    "1436"
  ],
  "./prism-arduino.js": [
    "15026",
    "56"
  ],
  "./prism-asmatmel.js": [
    "13784",
    "5538"
  ],
  "./prism-splunk-spl.js": [
    "80371",
    "2727"
  ],
  "./prism-toml.js": [
    "70132",
    "9686"
  ],
  "./prism-autohotkey.js": [
    "10845",
    "9205"
  ],
  "./prism-pascaligo.js": [
    "9427",
    "9763"
  ],
  "./prism-markup.js": [
    "64312",
    "4750"
  ],
  "./prism-solidity.js": [
    "43537",
    "1917"
  ],
  "./prism-scss.js": [
    "94604",
    "810"
  ],
  "./prism-smalltalk.js": [
    "18619",
    "7723"
  ],
  "./prism-hcl.js": [
    "55025",
    "5549"
  ],
  "./prism-livescript.js": [
    "86545",
    "6677"
  ],
  "./prism-actionscript.js": [
    "72513",
    "1957"
  ],
  "./prism-brainfuck.js": [
    "29905",
    "17"
  ],
  "./prism-kusto.js": [
    "59102",
    "8204"
  ],
  "./prism-objectivec.js": [
    "20596",
    "5826"
  ],
  "./prism-diff.js": [
    "47839",
    "4203"
  ],
  "./prism-elixir.js": [
    "84051",
    "7851"
  ],
  "./prism-gedcom.js": [
    "6497",
    "6745"
  ],
  "./prism-abap.js": [
    "90318",
    "8544"
  ],
  "./prism-docker.js": [
    "70568",
    "4270"
  ],
  "./prism-properties.js": [
    "41781",
    "7993"
  ],
  "./prism-prolog.js": [
    "16167",
    "9787"
  ],
  "./prism-editorconfig.js": [
    "33959",
    "9911"
  ],
  "./prism-stata.js": [
    "76263",
    "5747"
  ],
  "./prism-lua.js": [
    "80064",
    "3634"
  ],
  "./prism-gdscript.js": [
    "59616",
    "8262"
  ],
  "./prism-coffeescript.js": [
    "44511",
    "751"
  ],
  "./prism-nix.js": [
    "35177",
    "8013"
  ],
  "./prism-excel-formula.js": [
    "80130",
    "3396"
  ],
  "./prism-jexl.js": [
    "4993",
    "9985"
  ],
  "./prism-fortran.js": [
    "32048",
    "8526"
  ],
  "./prism-purebasic.js": [
    "32782",
    "1888"
  ],
  "./prism-wren.js": [
    "85794",
    "2988"
  ],
  "./prism-promql.js": [
    "24127",
    "883"
  ],
  "./prism-xquery.js": [
    "76108",
    "7294"
  ],
  "./prism-eiffel.js": [
    "39319",
    "6936"
  ],
  "./prism-flow.js": [
    "13028",
    "4550"
  ],
  "./prism-rust.js": [
    "75342",
    "5607"
  ],
  "./prism-core.js": [
    "71983",
    "5087"
  ],
  "./prism-css.js": [
    "91113",
    "5901"
  ],
  "./prism-less.js": [
    "18713",
    "357"
  ],
  "./prism-llvm.js": [
    "3801",
    "1209"
  ],
  "./prism-cfscript.js": [
    "68762",
    "6724"
  ],
  "./prism-markdown.js": [
    "75545",
    "7257"
  ],
  "./prism-lolcode.js": [
    "75224",
    "5414"
  ],
  "./prism-plant-uml.js": [
    "32580",
    "4522"
  ],
  "./prism-dhall.js": [
    "45293",
    "4338"
  ],
  "./prism-kotlin.js": [
    "69913",
    "105"
  ],
  "./prism-mongodb.js": [
    "86380",
    "6930"
  ],
  "./prism-gcode.js": [
    "50530",
    "9864"
  ],
  "./prism-vhdl.js": [
    "17822",
    "8168"
  ],
  "./prism-cpp.js": [
    "72415",
    "4275"
  ],
  "./prism-roboconf.js": [
    "45714",
    "6616"
  ],
  "./prism-bsl.js": [
    "79827",
    "3755"
  ],
  "./prism-scala.js": [
    "64252",
    "9326"
  ],
  "./prism-etlua.js": [
    "97595",
    "8411"
  ],
  "./prism-rip.js": [
    "89309",
    "1353"
  ],
  "./prism-turtle.js": [
    "9434",
    "2396"
  ],
  "./prism-jsdoc.js": [
    "16625",
    "753"
  ],
  "./prism-t4-templating.js": [
    "99948",
    "86"
  ],
  "./prism-false.js": [
    "45629",
    "9381"
  ],
  "./prism-io.js": [
    "17064",
    "1234"
  ],
  "./prism-liquid.js": [
    "57936",
    "8078"
  ],
  "./prism-phpdoc.js": [
    "7506",
    "3864"
  ],
  "./prism-hlsl.js": [
    "14023",
    "4479"
  ],
  "./prism-arturo.js": [
    "28239",
    "2647"
  ],
  "./prism-ejs.js": [
    "56258",
    "4468"
  ],
  "./prism-rego.js": [
    "38383",
    "4431"
  ],
  "./prism-ebnf.js": [
    "763",
    "8171"
  ],
  "./prism-keyman.js": [
    "54033",
    "8101"
  ],
  "./prism-solution-file.js": [
    "24686",
    "2812"
  ],
  "./prism-stylus.js": [
    "77382",
    "1148"
  ],
  "./prism-wasm.js": [
    "28176",
    "8254"
  ],
  "./prism-supercollider.js": [
    "95009",
    "7517"
  ],
  "./prism-armasm.js": [
    "18937",
    "9949"
  ],
  "./prism-verilog.js": [
    "71260",
    "1230"
  ],
  "./prism-opencl.js": [
    "58415",
    "9543"
  ],
  "./prism-c.js": [
    "50271",
    "8867"
  ],
  "./prism-gn.js": [
    "56633",
    "8965"
  ],
  "./prism-concurnas.js": [
    "16574",
    "9692"
  ],
  "./prism-tap.js": [
    "50803",
    "9939"
  ],
  "./prism-wgsl.js": [
    "66473",
    "1729"
  ],
  "./prism-aql.js": [
    "36184",
    "9122"
  ],
  "./prism-twig.js": [
    "1369",
    "5781"
  ],
  "./prism-applescript.js": [
    "17185",
    "3621"
  ],
  "./prism-arff.js": [
    "53487",
    "9063"
  ],
  "./prism-wiki.js": [
    "18524",
    "3026"
  ],
  "./prism-glsl.js": [
    "73980",
    "738"
  ],
  "./prism-latex.js": [
    "25294",
    "8392"
  ],
  "./prism-bro.js": [
    "19011",
    "4911"
  ],
  "./prism-protobuf.js": [
    "39535",
    "391"
  ],
  "./prism-dns-zone-file.js": [
    "21451",
    "3323"
  ],
  "./prism-pascal.js": [
    "97376",
    "4054"
  ],
  "./prism-puppet.js": [
    "48214",
    "6476"
  ],
  "./prism-bicep.js": [
    "65869",
    "4461"
  ],
  "./prism-json.js": [
    "72514",
    "5616"
  ],
  "./prism-ocaml.js": [
    "39814",
    "6368"
  ],
  "./prism-elm.js": [
    "76110",
    "8456"
  ],
  "./prism-hoon.js": [
    "47224",
    "3522"
  ],
  "./prism-j.js": [
    "54688",
    "1742"
  ],
  "./prism-velocity.js": [
    "38587",
    "5091"
  ],
  "./prism-groovy.js": [
    "75538",
    "6444"
  ],
  "./prism-parigp.js": [
    "94741",
    "5249"
  ],
  "./prism-php.js": [
    "43554",
    "6588"
  ],
  "./prism-racket.js": [
    "47702",
    "4832"
  ],
  "./prism-ada.js": [
    "40862",
    "1384"
  ],
  "./prism-robotframework.js": [
    "39860",
    "6290"
  ],
  "./prism-abnf.js": [
    "50151",
    "3503"
  ],
  "./prism-erb.js": [
    "57449",
    "8889"
  ],
  "./prism-awk.js": [
    "45167",
    "3535"
  ],
  "./prism-haxe.js": [
    "3700",
    "450"
  ],
  "./prism-psl.js": [
    "54121",
    "5637"
  ],
  "./prism-zig.js": [
    "15168",
    "2770"
  ],
  "./prism-apacheconf.js": [
    "84716",
    "3150"
  ],
  "./prism-cilkcpp.js": [
    "60000",
    "7086"
  ],
  "./prism-icon.js": [
    "90237",
    "4637"
  ],
  "./prism-clojure.js": [
    "70478",
    "1488"
  ],
  "./prism-aspnet.js": [
    "30559",
    "8763"
  ],
  "./prism-parser.js": [
    "27059",
    "6267"
  ],
  "./prism-hpkp.js": [
    "75839",
    "1855"
  ],
  "./prism-peoplecode.js": [
    "91166",
    "6880"
  ],
  "./prism-qml.js": [
    "93732",
    "6206"
  ],
  "./prism-stan.js": [
    "79032",
    "6502"
  ],
  "./prism-javadoc.js": [
    "36852",
    "2326"
  ],
  "./prism-js-extras.js": [
    "9799",
    "463"
  ],
  "./prism-web-idl.js": [
    "9274",
    "1052"
  ],
  "./prism-csp.js": [
    "58160",
    "2890"
  ],
  "./prism-magma.js": [
    "66867",
    "7407"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 27818;
module.exports = webpackAsyncContext;
